import React, { PropsWithChildren, ReactElement } from 'react';

export const TeaserText = ({ children }: PropsWithChildren): ReactElement => (
    <p className="text-secondary text-base leading-[18px] mb-5 leading-6">
        {children}
    </p>
);
